<template>
  <div class="registrationExtraAttributes">
    <h3 class="componentTitle mt-2 mb-4">
      <span v-if="title">{{ title }}</span>
      <span v-else>Custom Fields</span>
    </h3>

    <div v-if="keyified.length < 1">
      <p>There are no custom fields.</p>
    </div>
    <table class="formDataTable mb-2">
      <tr v-for="(fieldName, index) in keyified" :key="index"  class="py-4">
        <td valign="top" class="fieldNameCol py-2">
          <v-label color="primary" dark class="" :v-for="`extra-attribute-` + fieldName">{{ fieldName }}</v-label>
        </td>
        <td valign="top" class="fieldValueCol py-2">
          <v-textarea :id="`extra-attribute-` + fieldName" v-model="attributes[fieldName]" v-if="!isComplexObject(attributes[fieldName]) && editingFields[fieldName] == true"  outline></v-textarea>
          <span v-if="!(editingFields[fieldName] == true)">{{ attributes[fieldName] }}</span>
        </td>
        <td class="actions fieldActionsCol py-2 pl-2" v-align="top">
          <div v-if="!isComplexObject(attributes[fieldName])">
            <button v-if="editingFields[fieldName] == true" @click.stop.prevent="editField(fieldName)" title="View Field" alt="View Field"><i class="fas fa-check-circle"></i></button>
            <button v-else @click.stop.prevent="editField(fieldName)" title="Edit Field" alt="Edit Field"><v-icon>$vuetify.icons.amaze-edit</v-icon></button>
            <button class="mt-4" @click.stop.prevent="deleteField(fieldName)" title="Delete Field" alt="Delete Field"><i class="fas fa-trash-alt"></i></button>
          </div>
          <div v-else>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon color="primary" dark v-on="on">info</v-icon>
              </template>
              <span>Editing complex fields like {{ fieldName }} is not currently supported.</span>
            </v-tooltip>
          </div>
        </td>
      </tr>
    </table>

    <div class="newFieldContainer pt-4">
      <v-label><strong>Add New Custom Field</strong></v-label>
      <v-text-field v-model="newField"
        clearable
        placeholder="Enter the name of a new field"
        :hint="!canAddField ? `Enter a new field name, you cannot reuse an existing field name.` : ``">
        <template slot="label">
          Field Name
        </template>
      </v-text-field>
      <v-btn color="primary" @click.stop.prevent="addField()"  :disabled="!canAddField" required :rules="rules.populated">Add Field</v-btn>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "src/styles/variables.scss";
table {
  width:100%;
  border-collapse: collapse;
  i {
    color: $amaze-grey;
  }
  tr {
    td {
      border-bottom: 1px solid $another-light-gray;
      padding-right: 8px;
      &.fieldNameCol {
        max-width: 33%;
        width: 33%;
        word-break: break-all;
      }
      &.actions {
        vertical-align: top;
        button {
          height: 28px;
          display: block;
        }
      }
    }
  }
}
</style>
<script>
export default {
  props: ["attributes", "title"],
  data() {
    return {
      newField: "",
      showRawJson: true,
      showHiddenFields: false,
      editingFields: {},
      rules: {
        populated: [v => !!v || "This field is required."]
      }
    };
  },
  computed: {
    canAddField: function() {
      return this.newField && this.newField.length > 0 && !this.attributes[this.newField];
    },
    fields: function () {
      // Use this to apply shown / hidden filters.
      return this.json;
    },
    stringified: function () {
      // Use this to apply shown / hidden filters.
      return this.stringify(this.attributes);
    },
    keyified: function() {
      let keys = this.keyify(this.attributes);
      return keys ? this.keyify(this.attributes).sort() : [];
    }
  },
  methods: {
    deleteField: function(fieldName) {
      this.$delete(this.attributes, fieldName);
    },
    addField: function() {
      if (this.newField) {
        this.$set(this.attributes, this.newField, '');
        this.editField(this.newField);
        this.newField = "";
      }
    },
    editField: function(fieldName) {
      if (this.editingFields.hasOwnProperty(fieldName)) {
        this.$set(this.editingFields, fieldName, !this.editingFields[fieldName]);
      } else {
        this.$set(this.editingFields, fieldName, true);
      }
    },
    isComplexObject: function(isThisAnObject) {
      // If we don't want to allow arrays, then use this return statment.
      // return (!!isThisAnObject) && (isThisAnObject.constructor === Object || Array.isArray(isThisAnObject));
      return (!!isThisAnObject) && (isThisAnObject.constructor === Object);
    },
    keyify: function(jsonObject) {
      return jsonObject && typeof jsonObject === 'object' ? Object.keys(jsonObject) : null;
    },
    stringify: function(jsonObject) {
      return jsonObject && typeof jsonObject === 'object' ? JSON.stringify(jsonObject) : null;
    },
    objectify: function(jsonString) {
      return JSON.parse(jsonString);
    }
  }
};
</script>
